export const SET_LEARNER_MODULES_LOADING = "SET_LEARNER_MODULES_LOADING";
export const SET_LEARNER_MODULES_ERROR = "SET_LEARNER_MODULES_ERROR";

export const FETCH_LEARNER_MODULES_REQUEST = "FETCH_LEARNER_MODULES_REQUEST";
export const FETCH_LEARNER_MODULES_SUCCESS = "FETCH_LEARNER_MODULES_SUCCESS";
export const FETCH_LEARNER_MODULES_FAIL = "FETCH_LEARNER_MODULES_FAIL";

export const setLearnerModulesLoading = (payload) => ({
    type: SET_LEARNER_MODULES_LOADING,
    payload,
});

export const setLearnerModulesError = (payload) => ({
    type: SET_LEARNER_MODULES_ERROR,
    payload,
});

export const fetchLearnerModulesRequest = () => ({
    type: FETCH_LEARNER_MODULES_REQUEST,
});

export const fetchLearnerModulesSuccess = (payload) => ({
    type: FETCH_LEARNER_MODULES_SUCCESS,
    payload,
});

export const fetchLearnerModulesFail = (payload) => ({
    type: FETCH_LEARNER_MODULES_FAIL,
    payload,
});
